import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (process.env['NODE_ENV'] !== 'development') {
  enableProdMode();
}

(window as Window & typeof globalThis & { _appConf: { RELEASE_ID?: string } })._appConf = {
  RELEASE_ID: process.env['NX_RELEASE_ID'],
};

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
